const processes = (state) => state.processes;
const processTypes = (state) => state.processTypes;
const processStatus = (state) => state.processStatus;
const departaments = (state) => state.departaments;
const pendingProcesses = (state) => state.pendingProcesses;

export default {
  processes,
  processTypes,
  processStatus,
  departaments,
  pendingProcesses
};
